import 'bootstrap';

function handleVideoModalEvents(): void {
  const videoModalElement = document.getElementById('videoModal');
  const videoModalContentElement = document.getElementById('videoModalContent');
  const videoModalLabelElement = document.getElementById('videoModalLabel');

  if (videoModalElement && videoModalContentElement) {
    videoModalElement.addEventListener('show.bs.modal', (event: Event & { relatedTarget: HTMLElement }) => {
      const relatedTarget = event.relatedTarget;
      if (relatedTarget) {
        switch (relatedTarget.dataset.videoHost) {
          case 'youtube':
            const iframeTitle = relatedTarget.dataset.videoTitle || 'YouTube video player';
            if (relatedTarget.dataset.videoPlaylist === "true") {
              videoModalContentElement.innerHTML = `<iframe src="https://www.youtube.com/embed/videoseries?list=${relatedTarget.dataset.videoId}&controls=0&autoplay=1" title="${iframeTitle}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
            } else {
              videoModalContentElement.innerHTML = `<iframe src="https://www.youtube.com/embed/${relatedTarget.dataset.videoId}?controls=0&autoplay=1" title="${iframeTitle}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
            }
            break;
          case 'vimeo': {
            // Vimeo has no playlist embed like YouTube's, so a Vimeo "playlist" can't be played.
            if (relatedTarget.dataset.videoPlaylist === 'true') {
              console.warn('Vimeo playlists are not supported.');
              break;
            }

            // The iframe is built with DOM calls, not an HTML string, so the ID and title can't break out of their attributes.
            const vimeoIframe = document.createElement('iframe');
            vimeoIframe.src = `https://player.vimeo.com/video/${encodeURIComponent(relatedTarget.dataset.videoId ?? '')}?autoplay=1`;
            vimeoIframe.title = relatedTarget.dataset.videoTitle || 'Vimeo video player';
            vimeoIframe.setAttribute('frameborder', '0');
            // The permissions and referrer policy match Vimeo's own embed code. The referrer is what Vimeo checks for videos that are restricted to certain domains.
            vimeoIframe.allow = 'autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share';
            vimeoIframe.referrerPolicy = 'strict-origin-when-cross-origin';
            vimeoIframe.allowFullscreen = true;
            videoModalContentElement.replaceChildren(vimeoIframe);
            break;
          }
          default:
            console.warn(`Video host '${relatedTarget.dataset.videoHost}' not supported.`);
            break;
        }
        videoModalLabelElement.innerHTML = relatedTarget.attributes['aria-label'].value
      }
    });

    videoModalElement.addEventListener('hidden.bs.modal', () => {
      videoModalContentElement.innerHTML = '';
      videoModalLabelElement.innerHTML = '';
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  handleVideoModalEvents();
});
